import tw from 'tailwind-styled-components'

const SpanSwitch = tw.span`
pointer-events-none 
inline-block 
h-[16px] 
w-[16px] 
transform 
rounded-2xl 
bg-white 
shadow-lg 
ring-0 
transition 
duration-200 
ease-in-out
`
const switchStyles = `
relative 
inline-flex 
items-center 
h-[24px] 
w-[40px] 
shrink-0 
cursor-pointer 
rounded-full 
border-2 
border-transparent 
transition-colors 
duration-200 
ease-in-out 
focus:outline-none 
focus-visible:ring-2  
focus-visible:ring-white 
focus-visible:ring-opacity-75
`
export { SpanSwitch, switchStyles }
